/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Alerts_ExplainerInputs */

const he_account_alerts_explainer = /** @type {(inputs: Account_Alerts_ExplainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בחרו מה יפעיל התראה — מעקבים, ירידות מחיר וסף מחיר.`)
};

const en_account_alerts_explainer = /** @type {(inputs: Account_Alerts_ExplainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose what triggers a notification — subscriptions, price drops, and thresholds.`)
};

/**
* | output |
* | --- |
* | "Choose what triggers a notification — subscriptions, price drops, and thresholds." |
*
* @param {Account_Alerts_ExplainerInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_alerts_explainer = /** @type {((inputs?: Account_Alerts_ExplainerInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Alerts_ExplainerInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_alerts_explainer(inputs)
	return en_account_alerts_explainer(inputs)
});